import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routerPath } from "../../../../navigation/path";

import "./coverflow.css";

const CoverflowCarousel = ({ offers = [] }) => {
  const navigate = useNavigate();

  // Five slots are visible (2 left + center + 2 right), so repeat the
  // offers when there are too few to fill every slot.
  const slides = useMemo(() => {
    if (!offers.length) return [];
    let list = [...offers];
    while (list.length < 5) list = list.concat(offers);
    return list;
  }, [offers]);

  const [active, setActive] = useState(0);
  const pausedRef = useRef(false);

  useEffect(() => {
    if (slides.length < 2) return;
    const id = setInterval(() => {
      if (!pausedRef.current) {
        setActive((prev) => (prev + 1) % slides.length);
      }
    }, 2000);
    return () => clearInterval(id);
  }, [slides.length]);

  // Circular distance from the active card: 0 = center, 1/2 = right side,
  // -1/-2 = left side, null = hidden behind the center.
  const offsetFor = (index) => {
    const n = slides.length;
    const diff = (index - active + n) % n;
    if (diff <= 2) return diff;
    if (diff >= n - 2) return diff - n;
    return null;
  };

  const handleCardClick = (index, offer) => {
    if (offsetFor(index) === 0) {
      offer?.id
        ? navigate(`${routerPath.claimOffer}?offer_id=${offer.id}`)
        : console.log("Offer id is null");
    } else {
      setActive(index);
    }
  };

  if (!slides.length) return null;

  return (
    <div
      className="coverflow-carousel"
      onMouseEnter={() => (pausedRef.current = true)}
      onMouseLeave={() => (pausedRef.current = false)}
    >
      <div className="cf-stage">
        {slides.map((offer, index) => {
          const offset = offsetFor(index);
          const posClass =
            offset === null
              ? "cf-hidden"
              : `cf-pos${offset >= 0 ? offset : `-m${-offset}`}`;
          return (
            <div
              key={index}
              className={`cf-card w-[260px] sm:w-[320px] ${posClass} `}
              onClick={() => handleCardClick(index, offer)}
            >
              <div className="bg-white rounded-2xl shadow-2xl h-[220px] px-5 py-5 flex flex-col items-center justify-center text-center cursor-pointer">
                <div className="w-full h-[120px] mb-3 rounded-2xl overflow-hidden bg-gray-50">
                  <img
                    src={offer?.image1}
                    alt={offer?.name || ""}
                    className="w-full h-full object-contain"
                  />
                </div>
                {offer?.name && (
                  <p className="text-base font-bold text-gray-800 mb-0 line-clamp-1">
                    {offer.name}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CoverflowCarousel;
